import { createAsyncThunk } from '@reduxjs/toolkit';
// On utilise uniquement axiosService qui contient le token d'authentification
import axiosService from "../../../services/axiosServicesVisit"; 
import { API, API_URL } from '../../../config/api';

const api_url = API_URL + API.REGIONS.ADDREGION;

export const getRegions = createAsyncThunk(
  'regions/getRegions',
  async ({ page = 1, itemsPerPage = 1000, search = "", filter = {}, governmentId = null }, thunkAPI) => {

    const params = new URLSearchParams({
      page: String(page),
      limit: String(itemsPerPage),
      search: search || filter.regionSearch || '',
    });

    if (governmentId) {
      params.append('government', governmentId);
    }

    try {
      const response = await axiosService.get(api_url + `?${params.toString()}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addRegion = createAsyncThunk(
  'regions/addRegion',
  async (regionData, thunkAPI) => {
    try {
      const response = await axiosService.post(api_url, regionData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteRegion = createAsyncThunk(
  'regions/deleteRegion',
  async (regionId, thunkAPI) => {
    try {
      await axiosService.delete(`${api_url}/${regionId}`);
      return regionId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getRegionById = createAsyncThunk(
  'regions/getRegionById',
  async (regionId, thunkAPI) => {
    try {
      const response = await axiosService.get(`${api_url}/${regionId}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateRegion = createAsyncThunk(
  'regions/updateRegion',
  async ({ regionId, regionData }, thunkAPI) => {
    try {
      const response = await axiosService.patch(`${api_url}/${regionId}`, regionData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const filterRegions = createAsyncThunk(
  'regions/filterRegions',
  async (filterData, thunkAPI) => {
    try {
      const response = await axiosService.post(`${api_url}/filter`, filterData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const mergeRegions = createAsyncThunk(
  'regions/mergeRegions',
  async (regionIds, thunkAPI) => {
    try {
      const mergeApiUrl = API_URL + API.REGIONS.MERGE; 
      const response = await axiosService.post(mergeApiUrl, { regionIds });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);